import React, { FC } from 'react';
import { Chip } from '@mui/material';

interface IProps {
  label: string;
  color: string;
  outlined?: boolean;
}

export const StatusChip: FC<IProps> = ({ label, color, outlined = false }) => (
  <Chip
    label={label}
    variant={outlined ? 'outlined' : 'filled'}
    style={outlined
      ? { color, borderColor: color, backgroundColor: 'transparent' }
      : { backgroundColor: color, color: '#FFFFFF' }
    }
  />
);
